import React from "react";
import { ReactComponent as InfoIcon } from "../assets/icons/Info.svg";
import styled from "styled-components";
import { rem } from "polished";

const InfoNote: React.FunctionComponent = ({ children }) => {
  return (
    <Outer style={{ display: "flex", gap: 8 }}>
      <div>
        <InfoIcon />
      </div>
      <div>{children}</div>
    </Outer>
  );
};

export default InfoNote;

const Outer = styled.div`
  display: flex;
  gap: ${rem(8)};
`;
